import { Box, Typography } from "@mui/material";
import { t } from "i18next";
import PlaceCard from "../PlaceCard/PlaceCard";

interface PlacesListProps {
  places: any[];
  displayedPlaces: any[];
  setSelectedPlaceIndex: (index: number) => void;
  isSmallScreen: boolean;
}

const PlacesList: React.FC<PlacesListProps> = ({
  places,
  displayedPlaces,
  setSelectedPlaceIndex,
  isSmallScreen,
}) => {
  return (
    <Box
      display="grid"
      sx={{
        gridTemplateColumns: {
          xs: "repeat(auto-fill, minmax(145px, 1fr))",
          sm: "repeat(auto-fill, minmax(200px, 1fr))",
        },
        justifyContent: "center",
        alignContent: "center",
        gap: 2,
        mt: 2,
        width: "100%",
        maxWidth: isSmallScreen ? "100%" : "1100px",
        minHeight: "150px",
      }}
    >
      {displayedPlaces.length > 0 ? (
        displayedPlaces.map((place, index) => (
          <PlaceCard
            key={place.id}
            place={place}
            onClick={() => setSelectedPlaceIndex(index)}
          />
        ))
      ) : (
        <Box sx={{ gridColumn: "1 / -1", textAlign: "center" }}>
          <Typography variant="h6" color="text.secondary">
            {t("pages.historyReading.noResults")}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default PlacesList;
